import { advanceFormToQuery as formToQuery } from "./advanceFormToQuery";
import { advanceQueryToForm as queryToForm } from "./advanceQueryToForm";

export default { formToQuery, queryToForm };
